import { render, staticRenderFns } from "./EventLogoItem.vue?vue&type=template&id=5e18aea5&"
import script from "./EventLogoItem.vue?vue&type=script&lang=js&"
export * from "./EventLogoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e18aea5')) {
      api.createRecord('5e18aea5', component.options)
    } else {
      api.reload('5e18aea5', component.options)
    }
    module.hot.accept("./EventLogoItem.vue?vue&type=template&id=5e18aea5&", function () {
      api.rerender('5e18aea5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/events/steps/EventLogoItem.vue"
export default component.exports